import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {instructionPathZod} from './schemas';

const toolName = 'move-instruction' as const;

const argumentZod = z.object({
  fromPath: instructionPathZod.describe(
    'The current instruction path to rename, for example rules/brand.mdc, brand-guidelines/SKILL.md, or brand-guidelines/references.'
  ),
  toPath: instructionPathZod.describe(
    'The new path. Must keep the same parent folder.'
  ),
});

export const moveInstructionManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Move instruction',
  llmTool: {
    name: toolName,
    description:
      'Renames an agent instruction (rule, skill, companion file, or subfolder) by path in the current site. Renaming a skill folder or subfolder cascades to all descendants.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.AGENT_INSTRUCTIONS,
  permission: [{resource: 'SiteAgentInstructions', action: 'manage'}],
  confirmBeforeExecuting: true,
});

export type MoveInstructionArgumentType = z.infer<typeof argumentZod>;
